'use client';

import React from 'react';

import Link from 'next/link';

import Box from '@mui/material/Box';
import MuiLink from '@mui/material/Link';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import { InfoCard } from '@/components/cards';
import { useUserInfo } from '@/context/UserInfoContext';
import { DisplayConceptRef } from '@/lib/api';
import { topic_url } from '@/lib/utils';

/** Renders the authenticated homepage section for followed topics. */
const HomeTopicsSection: React.FC = () => {
  const { userInfo } = useUserInfo();

  if (!userInfo) {
    return null;
  }

  return (
    <Box component="section" sx={{ width: '100%', mb: 3 }} aria-labelledby="topics">
      <Typography id="topics" variant="h5" component="h2" sx={{ mb: 2 }}>
        Topics
      </Typography>
      <Stack spacing={3}>
        <InfoCard title="Followed Topics">
          {userInfo.followed_topics && userInfo.followed_topics.length > 0 ? (
            <Stack component="nav" spacing={1} aria-label="Followed topics">
              {userInfo.followed_topics.map((topic: DisplayConceptRef, index: number) => (
                <MuiLink
                  key={index}
                  component={Link}
                  href={topic_url(topic.cref)}
                  underline="none"
                  color="primary"
                >
                  {topic.display}
                </MuiLink>
              ))}
            </Stack>
          ) : (
            <Typography>You have no followed topics yet.</Typography>
          )}
        </InfoCard>
      </Stack>
    </Box>
  );
};

export default HomeTopicsSection;
